import React, { useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Box, Text } from 'roo-ui/components';
import { useModal } from 'lib/hooks';
import Modal from 'components/Modal';
import PointsEarnDisplay from 'components/PointsEarnDisplay';
import { Flag } from 'pages/Property/LegacyPropertyAvailability/RoomTypes/primitives';
import TextButton from 'components/TextButton';
import { useDataLayer } from 'hooks/useDataLayer';

const OfferPointsEarn = React.memo(({ pointsEarned, isClassic }) => {
  const { openModal, modalProps } = useModal();
  const { emitInteractionEvent } = useDataLayer();
  const qffPoints = get(pointsEarned, 'qffPoints');
  const qbrPoints = get(pointsEarned, 'qbrPoints');

  const handleOnClick = useCallback(() => {
    openModal();
    emitInteractionEvent({ type: 'Business Rewards Pop Up', value: `Link Selected` });
  }, [emitInteractionEvent, openModal]);

  return (
    <Box color="greys.steel">
      <Flag icon="qffPoints">
        {!isClassic && (
          <Fragment>
            <Text display="block" fontSize="base">
              Earn <PointsEarnDisplay {...qffPoints} /> Qantas Points^
            </Text>
            <Text display="block" fontSize="base">
              Plus <PointsEarnDisplay {...qbrPoints} /> Qantas Points{' '}
              <TextButton
                onClick={handleOnClick}
                color="greys.steel"
                hoverColor="greys.charcoal"
                fontSize="base"
                aria-label="Learn more about Qantas Business Rewards"
              >
                for your business
              </TextButton>
            </Text>
            <Modal {...modalProps} title="Qantas Business Rewards">
              <Text>
                Travelling for business? Add your Qantas Business Rewards membership ABN number to any domestic or international Qantas
                Hotels booking and your business* will earn 1 Qantas Point per A$1 spent.
              </Text>
            </Modal>
          </Fragment>
        )}
        {isClassic && <Text display="block">You will not earn Qantas Points on Classic Rewards offers</Text>}
      </Flag>
    </Box>
  );
});

OfferPointsEarn.propTypes = {
  pointsEarned: PropTypes.object.isRequired,
  isClassic: PropTypes.bool,
  inclusions: PropTypes.array,
};

OfferPointsEarn.defaultProps = {
  inclusions: [],
  isClassic: false,
};

OfferPointsEarn.displayName = 'OfferPointsEarn';

export default OfferPointsEarn;
